import * as React from 'react'
import { RouteComponentProps } from 'react-router'
import {
  IOrganizationTeamMemberInvite,
  IOrganizationTeamMemberUpdate,
  IOrgObj,
  IMap,
  IMemberSearchObject,
  IStateUser,
  IOrganizationTeamMemberUpdateDTO
} from '../../../types'
import TeamMemberBottomPanel from './TeamMemberBottomPanel'
import TeamMemberInnerForm, { IFormValuesSubmit } from './TeamMemberInnerForm'
import EntityHeaderTitle from 'src/components/ui/entity/EntityHeaderTitle'
import { phoneNumberSplit } from '../../../utils'
import { roles } from 'src/state/selectors'
import UIMessages from 'src/utils/ui-messages'

interface ITeamMemberFormProps {
  selectedOrg?: IOrgObj
  organizations: IMap<IOrgObj>
  teamMemberId: string
  currentTeamMember: IMemberSearchObject
  onSubmit: (teamMember: IOrganizationTeamMemberInvite | IOrganizationTeamMemberUpdate) => Promise<any>
  onUpdate: (teamMember: IOrganizationTeamMemberUpdateDTO) => Promise<any>
  fetchTeamMember: (id: string) => Promise<any>
  fetching: boolean
  processing: boolean
}

interface ITeamMemberFormState {
  isCompleted: boolean
}

class TeamMemberForm extends React.PureComponent<
  ITeamMemberFormProps & RouteComponentProps<any>,
  ITeamMemberFormState
> {
  private formRef = React.createRef<any>()

  constructor(props: any) {
    super(props)
    this.state = {
      isCompleted: false
    }
  }

  public componentDidMount() {
    this.props.fetchTeamMember(this.props.teamMemberId)
  }

  public render() {
    const { selectedOrg, organizations, currentTeamMember, processing, fetching } = this.props
    const { isCompleted } = this.state

    return (
      <section>
        {!currentTeamMember && (
          <div className='p2'>
            <EntityHeaderTitle>{UIMessages.teamMember.createTeamMember}</EntityHeaderTitle>
          </div>
        )}
        <TeamMemberInnerForm
          completed={isCompleted}
          fetching={fetching}
          formRef={this.formRef}
          isEdit={!!currentTeamMember}
          organizations={organizations}
          processing={processing}
          selectedOrg={selectedOrg}
          teamMember={currentTeamMember}
          onCancelClick={this.handleCancelClick}
          onSubmit={this.handleSubmit}
          onSubmitClick={this.handleSubmitButtonClick}
          onUpdate={this.handleUpdate}
        />
      </section>
    )
  }

  private handleSubmitButtonClick = () => {
    this.formRef.current.submitForm()
  }

  private showCompleted = () => {
    this.setState({ isCompleted: true }, () => this.props.history.goBack())
  }

  private handleSubmit = async (teamMember: IFormValuesSubmit) => {
    const { countryCode, phoneNumber } = phoneNumberSplit(teamMember.phoneNumber ? teamMember.phoneNumber : '')
    // const jsonStringArray = teamMember.roles.map(role => JSON.stringify(role))
    // const parsedRoles = jsonStringArray.map(roleStr => JSON.parse(roleStr))
    // const parsedIds = parsedRoles.map(role => role.id)
    // const roleNames = parsedRoles.map(role => role.roleName)
    const roleObjects = [
      {
        id: '0d9a4bab-e25a-49e3-9e26-6765fcade838',
        type: 'ORGANIZATION',
        roleName: 'ORGANIZATION_ADMIN',
        name: 'Admin'
      },
      {
        id: '5cdba283-f16a-4898-9184-946c216b4557',
        type: 'ORGANIZATION',
        roleName: 'ORGANIZATION_DISPATCHER',
        name: 'Dispatcher'
      }
    ]

    const parsedIds = teamMember.roles.map(role => {
      const roleObject = roleObjects.find(roleObject => roleObject.roleName === role)

      if (roleObject !== undefined) {
        return roleObject.id
      } else {
        return ''
      }
    })
    const roleNames = teamMember.roles
    return this.props
      .onSubmit({
        ...teamMember,
        phoneNumber,
        countryCode,
        roleIds: parsedIds,
        roles: roleNames
      })
      .then(this.showCompleted)
  }

  private handleUpdate = async (teamMember: IOrganizationTeamMemberUpdateDTO) => {
    const { countryCode, phoneNumber } = phoneNumberSplit(teamMember.phoneNumber ? teamMember.phoneNumber : '')
    // const jsonStringArray = teamMember.roles.map(role => JSON.stringify(role))
    // const parsedRoles = jsonStringArray.map(roleStr => JSON.parse(roleStr))
    // // const parsedIds = parsedRoles.map(role => role.id)
    // const roleNames = parsedRoles.map(role => role.roleName)
    const roleObjects = [
      {
        id: '0d9a4bab-e25a-49e3-9e26-6765fcade838',
        type: 'ORGANIZATION',
        roleName: 'ORGANIZATION_ADMIN',
        name: 'Admin'
      },
      {
        id: '5cdba283-f16a-4898-9184-946c216b4557',
        type: 'ORGANIZATION',
        roleName: 'ORGANIZATION_DISPATCHER',
        name: 'Dispatcher'
      }
    ]

    const parsedIds = teamMember.roles.map(role => {
      const roleObject = roleObjects.find(roleObject => roleObject.roleName === role)

      if (roleObject !== undefined) {
        return roleObject.id
      } else {
        return ''
      }
    })
    const roleNames = teamMember.roles
    return this.props
      .onUpdate({
        ...teamMember,
        phoneNumber,
        countryCode,
        roleIds: parsedIds,
        roles: roleNames
      })
      .then(this.showCompleted)
  }

  private handleCancelClick = () => {
    this.props.history.goBack()
  }
}

export default TeamMemberForm



// WEBPACK FOOTER //
// ./src/components/team-members/form/TeamMemberForm.tsx